module.exports = __webpack_public_path__ + "static/media/WelcomeToFireflyWithoutFirefly.b09beaee.svg";